import Api from "./api";

export const getById = async (id) => {
    let data = [];
    await Api.get(`/articles/${id}`)
        .then(result => {
            data = result.data
        })
        .catch(err => {
            data = err;
        });
    return data;
}